/* unplugin-vue-components disabled */import script from "./CenterDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./CenterDialog.vue?vue&type=script&lang=ts&setup=true"

import "./CenterDialog.vue?vue&type=style&index=0&id=57a50b7d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57a50b7d"]])

export default __exports__